import React, { useEffect, useState, useRef, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, CircleIcon, ShieldCheckIcon, LockIcon, ArrowLeftIcon, ArrowDownIcon, ClockIcon } from 'lucide-react';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
interface OrderBump {
  id: string;
  title: string;
  bannerTitle: string;
  subtitle: string;
  description: string;
  price: number;
  imageUrl: string;
  selected: boolean;
  features: string[];
  incomePotential?: string;
}
export function CheckoutPage() {
  const [timeLeft, setTimeLeft] = useState(900); // 15 minutes
  const [megaBundleSelected, setMegaBundleSelected] = useState(false);
  const [orderBumps, setOrderBumps] = useState<OrderBump[]>([{
    id: 'primer-cliente',
    title: 'El Kit del Primer Cliente',
    bannerTitle: 'Kit del Primer Cliente',
    subtitle: '5 Guiones Copiar y Pegar por Nicho',
    description: 'Consigue tu primer cliente hoy mismo con guiones probados',
    price: 9,
    imageUrl: 'https://cdn.magicpatterns.com/uploads/wEW3tQ1afzybvBsGHR6DuQ/Order_1_Kit_Del_primer_Cliente.png',
    selected: false,
    incomePotential: '$350-$1,050 primera semana',
    features: ['Guión para Restaurantes', 'Guión para Dentistas', 'Guión para Talleres', 'Guión para Peluquerías', 'Guión para Tiendas']
  }, {
    id: 'ingresos-recurrentes',
    title: 'La Máquina de Ingresos Recurrentes',
    bannerTitle: 'Ingresos Recurrentes',
    subtitle: 'Convierte cada cliente en $99/mes',
    description: 'Ingresos pasivos predecibles todos los meses',
    price: 9,
    imageUrl: 'https://cdn.magicpatterns.com/uploads/4K5NokxDA2phWGPgcjq8XC/order_Bump2_La_Maquina_De_Ingresos_Recurrentes.png',
    selected: false,
    incomePotential: '$99/mes por cliente',
    features: ['Sistema de ingresos mensuales', 'Plantillas de propuestas recurrentes', 'Scripts de venta de mantenimiento', 'Calculadora de ingresos pasivos', 'Estrategia de retención de clientes']
  }, {
    id: 'google-reviews',
    title: 'Google Reviews Domination Kit',
    bannerTitle: 'Google Reviews Kit',
    subtitle: 'Consigue 20+ reseñas en 7 días',
    description: 'El sistema exacto para generar reseñas reales sin perseguir a nadie. Servicio listo para cobrar $200-$500/mes.',
    price: 9,
    imageUrl: 'https://cdn.magicpatterns.com/uploads/ugCrkE8a25GreYCaVHnbFY/Order_Bump3_Google_Reviews.png',
    selected: false,
    incomePotential: '$200-$500/mes por cliente',
    features: ['Reseñas reales sin perseguir a nadie', 'Servicio listo para cobrar $200-$500/mes', 'Clientes que te contratan antes de hablar contigo', 'Templates y secuencias ya escritas', 'Convierte tu primer cliente en máquina de credibilidad']
  }, {
    id: 'google-business',
    title: 'Google Business Profile Masterclass',
    bannerTitle: 'Google Business Profile',
    subtitle: 'Aparece #1 en Google sin pagar un solo dólar en ads',
    description: 'Dale a tus clientes el servicio que más buscan y menos entienden. El activo local más poderoso — mal usado por el 90%.',
    price: 9,
    imageUrl: 'https://cdn.magicpatterns.com/uploads/sc1xcruTXh9G4te7nYUSm7/order_Bump4_Google_Business.png',
    selected: false,
    incomePotential: '$150-$300/mes por cliente',
    features: ['Perfil optimizado que atrae clientes solo', 'Servicio recurrente de $150-$300/mes', 'Configuración estratégica que puedes hacer hoy', 'El activo local más poderoso del mercado', 'Deja de dejar dinero en perfiles a medias']
  }, {
    id: 'templates-cierre',
    title: '50 Templates de Cierre con IA',
    bannerTitle: '50 Templates de Cierre',
    subtitle: '50 respuestas ganadoras para cada objeción',
    description: 'No pierdas el cierre por no saber qué decir cuando te digan que no. Estructuras probadas listas para copiar y pegar.',
    price: 9,
    imageUrl: 'https://cdn.magicpatterns.com/uploads/9r8QNYRiMsyNChsjQp5sc2/Order_Bump_5_50_Templates_De_Cierre.png',
    selected: false,
    incomePotential: '+$300-$800 por cierre extra',
    features: ['"Lo voy a pensar" — respondido', '"Está muy caro" — respondido', '"Ya tengo alguien" — respondido', 'Estructuras probadas copiar y pegar', 'Deja de perder clientes listos para decir sí']
  }, {
    id: 'prospeccion-instantanea',
    title: 'Kit de Prospección Instantánea',
    bannerTitle: 'Prospección Instantánea',
    subtitle: '100 contactos calificados en 30 minutos con Google Maps',
    description: 'No arranques buscando leads a mano uno por uno. Prospección quirúrgica con intención de compra.',
    price: 9,
    imageUrl: 'https://cdn.magicpatterns.com/uploads/fBccnwm5Wk2XAQsDmiEoRu/Order_Bump_6_Kit_De_Prospeccion.png',
    selected: false,
    incomePotential: '$300-$800/semana',
    features: ['Leads listos sin herramientas caras', 'Pipeline de $300-$800 por semana', 'Negocios que ya necesitan lo que tú ofreces', 'Prospección quirúrgica con intención de compra', 'Deja de perder tiempo buscando a quién llamar']
  }, {
    id: 'propuestas-profesionales',
    title: 'Pack de Propuestas Profesionales',
    bannerTitle: 'Propuestas Profesionales',
    subtitle: 'Genera una propuesta premium en menos de 5 minutos con IA',
    description: 'No dejes que una propuesta mal hecha te baje el ticket en el último segundo. Estructura de agencia que vende autoridad.',
    price: 9,
    imageUrl: 'https://cdn.magicpatterns.com/uploads/nruHH8nyuiEe8ZR6sFYxXu/Order_Bump_7_Pack_De_Respuestas.png',
    selected: false,
    incomePotential: '+$200-$500 por cliente',
    features: ['Propuesta lista antes de que terminen de preguntar', 'Presentación que justifica precios más altos', 'La diferencia entre "te mando algo" y cerrar en la llamada', 'Estructura de agencia que vende autoridad', 'Deja de perder clientes que se enfriaron esperando']
  }, {
    id: 'guia-precios',
    title: 'Guía de Precios de Servicios IA',
    bannerTitle: 'Guía de Precios',
    subtitle: 'Arma ofertas combinadas de $3k+/mes',
    description: 'No sigas vendiendo baratos por no saber cómo estructurar tus paquetes. Reempaqueta lo que ya tienes para que valga más.',
    price: 9,
    imageUrl: 'https://cdn.magicpatterns.com/uploads/riFoWGP878omsQyLJfYg8A/Order_Bump_8_Guia_De_Precios.png',
    selected: false,
    incomePotential: '$3,000+/mes por cliente',
    features: ['Nunca más cobrar por hora ni undercharge', 'Paquetes que se venden solos sin justificar el precio', 'De servicios sueltos a retainer recurrente de alto ticket', 'Reempaqueta lo que ya tienes para que valga más', 'Deja de trabajar el doble por la mitad']
  }]);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  const summaryRef = useRef<HTMLDivElement>(null);
  const [summaryVisible, setSummaryVisible] = useState(false);
  useEffect(() => {
    const el = summaryRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => setSummaryVisible(entry.isIntersecting), {
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const basePrice = 27;
  const megaBundlePrice = 54;
  const allBumpsTotal = orderBumps.reduce((sum, b) => sum + b.price, 0);
  const selectedBumpsTotal = megaBundleSelected ? megaBundlePrice : orderBumps.filter(b => b.selected).reduce((sum, b) => sum + b.price, 0);
  const totalPrice = basePrice + selectedBumpsTotal;
  const toggleMegaBundle = () => {
    const newValue = !megaBundleSelected;
    setMegaBundleSelected(newValue);
    setOrderBumps(prev => prev.map(bump => ({
      ...bump,
      selected: newValue
    })));
  };
  const toggleBump = (id: string) => {
    if (megaBundleSelected) {
      setMegaBundleSelected(false);
    }
    setOrderBumps(prev => prev.map(bump => bump.id === id ? {
      ...bump,
      selected: !bump.selected
    } : bump));
  };
  // Shopify Cart Permalink Configuration
  const SHOPIFY_CONFIG = {
    shopDomain: 'offer.aiwebcloser.com',
    mainVariant: '48181018525944',
    products: {
      'primer-cliente': '48181021901048',
      'ingresos-recurrentes': '48181023310072',
      'google-reviews': '48234606461176',
      'google-business': '48234601316600',
      'templates-cierre': '48234602823928',
      'prospeccion-instantanea': '48234602889464',
      'propuestas-profesionales': '48234604429560',
      'guia-precios': '48234604855544'
    } as Record<string, string>,
    megaBundleVariant: '48234594009336',
    discountCode: ''
  };
  const getSelectedProducts = (): string[] => {
    const items: string[] = [`${SHOPIFY_CONFIG.mainVariant}:1`];
    if (megaBundleSelected) {
      items.push(`${SHOPIFY_CONFIG.megaBundleVariant}:1`);
    } else {
      const selectedBumps = orderBumps.filter(b => b.selected);
      for (const bump of selectedBumps) {
        const variantId = SHOPIFY_CONFIG.products[bump.id];
        if (variantId && !items.includes(`${variantId}:1`)) {
          items.push(`${variantId}:1`);
        }
      }
    }
    return items;
  };
  const buildCartUrl = (): string => {
    const items = getSelectedProducts();
    let url = `https://${SHOPIFY_CONFIG.shopDomain}/cart/${items.join(',')}`;
    const params: string[] = [];
    if (SHOPIFY_CONFIG.discountCode) {
      params.push(`discount=${SHOPIFY_CONFIG.discountCode}`);
    }
    // Add UTM params from current URL if present
    const urlParams = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_content', 'utm_term'];
    for (const key of utmKeys) {
      const value = urlParams.get(key);
      if (value) {
        params.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    return url;
  };
  const redirectToCheckout = () => {
    const url = buildCartUrl();
    window.location.href = url;
  };
  const getCheckoutUrl = () => {
    return buildCartUrl();
  };
  return <div className="min-h-screen bg-navy font-body text-white" data-id="element-998">
      {/* Header */}
      <header className="border-b border-gold/20 bg-navy-dark" data-id="element-999">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-1000">
          <a href="/" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-1001">
            <ArrowLeftIcon className="h-5 w-5" data-id="element-1002" />
            <span className="font-body text-sm" data-id="element-1003">Volver</span>
          </a>
          <div className="flex items-center gap-2" data-id="element-1004">
            <h1 className="font-heading font-black text-xl md:text-2xl" data-id="element-1005">
              <span className="text-gold" data-id="element-1006">AI</span> Web Closer
            </h1>
          </div>
          <div className="flex items-center gap-2 text-green-500" data-id="element-1007">
            <ShieldCheckIcon className="h-5 w-5" data-id="element-1008" />
            <span className="font-body text-sm hidden md:inline" data-id="element-1009">
              Pago Seguro
            </span>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 py-4 md:py-8" data-id="element-1010">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1011">
          {/* Left Column - Order Details */}
          <div className="lg:col-span-2 space-y-6" data-id="element-1012">
            {/* Progress Indicator */}
            <div className="flex items-center gap-2 mb-6" data-id="element-1013">
              <div className="flex items-center gap-2" data-id="element-1014">
                <div className="w-8 h-8 rounded-full bg-gold flex items-center justify-center" data-id="element-1015">
                  <span className="font-heading font-bold text-navy text-sm" data-id="element-1016">
                    1
                  </span>
                </div>
                <span className="font-body text-sm text-white" data-id="element-1017">
                  Revisa tu orden
                </span>
              </div>
              <div className="flex-1 h-0.5 bg-gold/20" data-id="element-1018" />
              <div className="flex items-center gap-2" data-id="element-1019">
                <div className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center" data-id="element-1020">
                  <span className="font-heading font-bold text-gray-500 text-sm" data-id="element-1021">
                    2
                  </span>
                </div>
                <span className="font-body text-sm text-gray-500" data-id="element-1022">Pago</span>
              </div>
            </div>

            {/* Main Product */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="bg-gradient-to-br from-navy-dark to-navy border-2 border-gold/30 rounded-xl p-3 md:p-6" data-id="element-1023">
              <div className="flex items-start gap-2 md:gap-4 mb-2 md:mb-3" data-id="element-1024">
                <div className="flex-shrink-0 w-14 h-14 md:w-20 md:h-20 rounded-lg overflow-hidden" data-id="element-1025">
                  <img src="https://cdn.magicpatterns.com/uploads/aaxD4trvMs9V7mqy2FbiHX/heylloyd-image-1775153064115_(1).jpg" alt="AI Web Closer System" className="w-full h-full object-cover rounded-lg" data-id="element-1026" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-1027">
                  <h2 className="font-heading font-bold text-base md:text-2xl mb-0.5 md:mb-1" data-id="element-1028">
                    AI Web Closer System
                  </h2>
                  <p className="font-body text-gray-300 text-xs md:text-sm" data-id="element-1029">
                    Acceso completo al curso + cerebros de IA + guiones +
                    calculadora
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-1030">
                  <p className="font-heading font-black text-xl md:text-3xl text-gold" data-id="element-1031">
                    ${basePrice}
                  </p>
                  <p className="font-body text-[10px] md:text-xs text-gray-400" data-id="element-1032">
                    pago único
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-4 gap-2 pt-2 md:pt-3 border-t border-gold/10" data-id="element-1033">
                <div className="text-center" data-id="element-1034">
                  <p className="font-heading font-bold text-gold text-sm md:text-base" data-id="element-1035">
                    4
                  </p>
                  <p className="font-body text-[9px] md:text-xs text-gray-400" data-id="element-1036">
                    Módulos
                  </p>
                </div>
                <div className="text-center" data-id="element-1037">
                  <p className="font-heading font-bold text-gold text-sm md:text-base" data-id="element-1038">
                    2
                  </p>
                  <p className="font-body text-[9px] md:text-xs text-gray-400" data-id="element-1039">
                    Cerebros IA
                  </p>
                </div>
                <div className="text-center" data-id="element-1040">
                  <p className="font-heading font-bold text-gold text-sm md:text-base" data-id="element-1041">
                    5
                  </p>
                  <p className="font-body text-[9px] md:text-xs text-gray-400" data-id="element-1042">
                    Guiones
                  </p>
                </div>
                <div className="text-center" data-id="element-1043">
                  <p className="font-heading font-bold text-gold text-sm md:text-base" data-id="element-1044">
                    ∞
                  </p>
                  <p className="font-body text-[9px] md:text-xs text-gray-400" data-id="element-1045">
                    Acceso
                  </p>
                </div>
              </div>
            </motion.div>

            {/* MEGA BUNDLE */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.15
          }} onClick={toggleMegaBundle} className={`relative cursor-pointer rounded-xl overflow-hidden transition-all duration-300 ${megaBundleSelected ? 'ring-2 ring-emerald-400 shadow-2xl shadow-emerald-500/30' : 'ring-1 ring-emerald-500/40 hover:ring-emerald-400/60'}`} data-id="element-1046">
              {/* Popular Badge */}
              <div className="bg-emerald-600 text-center px-4 py-1" data-id="element-1047">
                <span className="font-heading font-bold text-emerald-100 text-[10px] md:text-[11px] uppercase tracking-[0.2em]" data-id="element-1048">
                  ⭐ Paquete más comprado y recomendado
                </span>
              </div>
              {/* Top Banner */}
              <div className="bg-gradient-to-r from-emerald-900 via-emerald-800 to-emerald-900 px-4 py-3 md:py-4 flex items-center justify-between border-b border-emerald-500/30" data-id="element-1049">
                <div className="flex items-center gap-2" data-id="element-1050">
                  <span className="font-heading font-black text-white text-base md:text-xl uppercase tracking-wide" data-id="element-1051">
                    MEGA BUNDLE
                  </span>
                  <span className="font-body text-emerald-300 text-xs md:text-sm" data-id="element-1052">
                    — Todos los paquetes
                  </span>
                </div>
                <span className="font-heading font-black text-emerald-900 text-[10px] md:text-xs bg-emerald-400 px-2.5 py-1 rounded-full" data-id="element-1053">
                  -25% EXTRA
                </span>
              </div>

              <div className="bg-gradient-to-br from-navy-dark via-navy to-navy-dark p-4 md:p-6" data-id="element-1054">
                <div className="flex items-start gap-3" data-id="element-1055">
                  {/* Checkbox */}
                  <motion.div animate={{
                  scale: megaBundleSelected ? 1.1 : 1
                }} transition={{
                  duration: 0.2
                }} className="flex-shrink-0 mt-1" data-id="element-1056">
                    {megaBundleSelected ? <div className="relative w-7 h-7" data-id="element-1057">
                        <div className="absolute inset-0 bg-gold rounded-full" data-id="element-1058" />
                        <CheckCircleIcon className="relative h-7 w-7 text-navy" strokeWidth={3} data-id="element-1059" />
                      </div> : <CircleIcon className="h-7 w-7 text-gold/60" data-id="element-1060" />}
                  </motion.div>

                  {/* Content */}
                  <div className="flex-1" data-id="element-1061">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3 mb-3" data-id="element-1062">
                      <div data-id="element-1063">
                        <h4 className="font-heading font-bold text-lg md:text-2xl mb-1" data-id="element-1064">
                          Llévate TODO el Arsenal Completo
                        </h4>
                        <p className="font-body text-xs md:text-sm text-gold mb-1" data-id="element-1065">
                          Los 8 paquetes incluidos — sin elegir, sin dejar nada
                          fuera
                        </p>
                        <p className="font-body text-xs text-gray-400" data-id="element-1066">
                          💡{' '}
                          <span className="text-white font-semibold" data-id="element-1067">
                            1 sola venta recupera TODA tu inversión
                          </span>{' '}
                          — y lo que sigue es ganancia pura.
                        </p>
                      </div>
                      <div className="flex-shrink-0 sm:text-right flex flex-col items-start sm:items-end gap-1" data-id="element-1068">
                        <div className="flex items-center gap-1.5" data-id="element-1069">
                          <span className="font-body text-sm text-gray-400 line-through decoration-gray-400/50" data-id="element-1070">
                            ${allBumpsTotal + basePrice > 0 ? `$776` : ''}
                          </span>
                          <span className="font-body text-xs text-gray-400 line-through decoration-gray-400/50" data-id="element-1071">
                            ${allBumpsTotal}
                          </span>
                          <span className="bg-green-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded flex items-center gap-0.5" data-id="element-1072">
                            <ArrowDownIcon className="w-2.5 h-2.5" data-id="element-1073" /> 93%
                          </span>
                        </div>
                        <div className="bg-gold text-navy px-4 py-2 rounded-lg" data-id="element-1074">
                          <p className="font-heading font-black text-2xl md:text-3xl" data-id="element-1075">
                            ${megaBundlePrice}
                          </p>
                        </div>
                        <p className="font-body text-[10px] text-gray-500" data-id="element-1076">
                          en vez de ${allBumpsTotal} por separado
                        </p>
                      </div>
                    </div>

                    {/* Bump names grid */}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-1 md:gap-1.5" data-id="element-1077">
                      {orderBumps.map(bump => <div key={bump.id} className="flex items-center gap-1" data-id="element-1078">
                          <CheckCircleIcon className="h-3 w-3 text-gold flex-shrink-0" data-id="element-1079" />
                          <span className="font-body text-[10px] md:text-[11px] text-gray-300 truncate" data-id="element-1080">
                            {bump.bannerTitle}
                          </span>
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>

              {/* Selection Indicator */}
              {megaBundleSelected && <motion.div initial={{
              scaleX: 0
            }} animate={{
              scaleX: 1
            }} className="h-1.5 bg-gradient-to-r from-gold via-yellow-400 to-gold" data-id="element-1081" />}
            </motion.div>

            {/* Divider */}
            <div className="flex items-center gap-3" data-id="element-1082">
              <div className="flex-1 h-px bg-gold/20" data-id="element-1083" />
              <span className="font-heading font-bold text-xs text-gray-500 uppercase tracking-widest" data-id="element-1084">
                o elige por separado
              </span>
              <div className="flex-1 h-px bg-gold/20" data-id="element-1085" />
            </div>

            {/* Order Bumps Section */}
            <div data-id="element-1086">
              <div className="mb-3 md:mb-4 flex flex-col md:flex-row md:items-center justify-between gap-2" data-id="element-1087">
                <div data-id="element-1088">
                  <h3 className="font-heading font-bold text-base md:text-xl text-gold mb-1" data-id="element-1089">
                    ⚡ Compra Junto y Ahorra 91%!
                  </h3>
                  <p className="font-body text-xs text-gray-400" data-id="element-1090">
                    Haz clic para añadir a tu orden
                  </p>
                </div>
                <div className="flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 text-red-500 px-3 py-1.5 rounded-lg self-start md:self-auto" data-id="element-1091">
                  <ClockIcon className="w-4 h-4" data-id="element-1092" />
                  <span className="font-heading font-bold text-sm" data-id="element-1093">
                    Oferta expira en: {formatTime(timeLeft)}
                  </span>
                </div>
              </div>

              <div className="space-y-2 md:space-y-3" data-id="element-1094">
                {orderBumps.map((bump, index) => <motion.div key={bump.id} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: 0.2 + index * 0.1
              }} onClick={() => toggleBump(bump.id)} className={`
                      relative cursor-pointer rounded-xl overflow-hidden transition-all duration-300
                      ${bump.selected ? 'ring-2 ring-gold shadow-2xl shadow-gold/20' : 'ring-1 ring-gold/30 hover:ring-gold/50'}
                    `} data-id="element-1095">
                    {/* Gold Banner */}
                    <div className="bg-gold px-3 py-1.5 md:px-4 md:py-2.5 flex items-center justify-between" data-id="element-1096">
                      <span className="font-heading font-black text-navy text-xs md:text-base uppercase tracking-wide" data-id="element-1097">
                        ⚡ {bump.bannerTitle}
                      </span>
                      <span className="font-heading font-bold text-navy text-[10px] md:text-xs bg-navy/15 px-1.5 py-0.5 rounded" data-id="element-1098">
                        +${bump.price}
                      </span>
                    </div>

                    <div className="bg-gradient-to-br from-navy-dark to-navy p-2.5 md:p-4" data-id="element-1099">
                      <div className="flex items-start gap-2 md:gap-3" data-id="element-1100">
                        {/* Checkbox */}
                        <motion.div animate={{
                      scale: bump.selected ? 1.1 : 1
                    }} transition={{
                      duration: 0.2
                    }} className="flex-shrink-0 mt-0.5" data-id="element-1101">
                          {bump.selected ? <div className="relative w-5 h-5 md:w-6 md:h-6" data-id="element-1102">
                              <div className="absolute inset-0 bg-gold rounded-full" data-id="element-1103" />
                              <CheckCircleIcon className="relative h-5 w-5 md:h-6 md:w-6 text-navy" strokeWidth={3} data-id="element-1104" />
                            </div> : <CircleIcon className="h-5 w-5 md:h-6 md:w-6 text-gold/60" data-id="element-1105" />}
                        </motion.div>

                        {/* Product Image */}
                        {bump.imageUrl && <div className="flex-shrink-0" data-id="element-1106">
                            <img src={bump.imageUrl} alt={bump.title} className="w-16 h-16 sm:w-16 sm:h-16 object-contain rounded" data-id="element-1107" />
                          </div>}

                        {/* Content */}
                        <div className="flex-1 min-w-0" data-id="element-1108">
                          <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-1.5 sm:gap-3 mb-1.5 md:mb-3" data-id="element-1109">
                            <div className="min-w-0" data-id="element-1110">
                              <h4 className="font-heading font-bold text-sm md:text-xl mb-0.5 truncate" data-id="element-1111">
                                {bump.title}
                              </h4>
                              <p className="font-body text-[10px] md:text-xs text-gold mb-0.5 md:mb-1" data-id="element-1112">
                                {bump.subtitle}
                              </p>
                              <p className="font-body text-[10px] md:text-xs text-gray-400 hidden md:block" data-id="element-1113">
                                {bump.description}
                              </p>
                              {bump.incomePotential && <div className="mt-1 md:mt-1.5 inline-flex items-center gap-1 bg-green-500/10 border border-green-500/30 px-2 py-0.5 rounded-md" data-id="element-1114">
                                  <span className="text-green-400 text-[10px] md:text-xs font-bold" data-id="element-1115">
                                    Ingreso potencial: {bump.incomePotential}
                                  </span>
                                </div>}
                            </div>
                            <div className="flex-shrink-0 sm:text-right flex flex-row sm:flex-col items-center sm:items-end gap-1.5 sm:gap-1" data-id="element-1116">
                              <div className="flex items-center gap-1" data-id="element-1117">
                                <span className="font-body text-xs md:text-sm text-gray-400 line-through decoration-gray-400/50" data-id="element-1118">
                                  $97.00
                                </span>
                                <span className="bg-green-600 text-white text-[9px] md:text-[10px] font-bold px-1 md:px-1.5 py-0.5 rounded flex items-center gap-0.5" data-id="element-1119">
                                  <ArrowDownIcon className="w-2 h-2 md:w-2.5 md:h-2.5" data-id="element-1120" />{' '}
                                  91%
                                </span>
                              </div>
                              <div className="bg-gold text-navy px-2 py-1 md:px-3 md:py-1.5 rounded-lg" data-id="element-1121">
                                <p className="font-heading font-black text-base md:text-xl" data-id="element-1122">
                                  ${bump.price}
                                </p>
                              </div>
                            </div>
                          </div>

                          {/* Features */}
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-0.5 md:gap-1.5" data-id="element-1123">
                            {bump.features.map((feature, idx) => <div key={idx} className="flex items-center gap-1 md:gap-1.5" data-id="element-1124">
                                <CheckCircleIcon className="h-3 w-3 md:h-3.5 md:w-3.5 text-gold flex-shrink-0" data-id="element-1125" />
                                <span className="font-body text-[10px] md:text-[11px] text-gray-300" data-id="element-1126">
                                  {feature}
                                </span>
                              </div>)}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Selection Indicator */}
                    {bump.selected && <motion.div initial={{
                  scaleX: 0
                }} animate={{
                  scaleX: 1
                }} className="h-1 bg-gradient-to-r from-gold via-gold-light to-gold" data-id="element-1127" />}
                  </motion.div>)}
              </div>
            </div>
          </div>

          {/* Right Column - Order Summary (Sticky) */}
          <div className="lg:col-span-1" ref={summaryRef} data-id="element-1128">
            <div className="sticky top-4" data-id="element-1129">
              <motion.div initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} className="bg-gradient-to-br from-navy-dark to-navy border border-gold/30 rounded-xl p-6 shadow-2xl" data-id="element-1130">
                <h3 className="font-heading font-bold text-xl mb-4 pb-4 border-b border-gold/20" data-id="element-1131">
                  Resumen de Orden
                </h3>

                {/* Line Items */}
                <div className="space-y-3 mb-4" data-id="element-1132">
                  <div className="flex items-center justify-between" data-id="element-1133">
                    <span className="font-body text-sm text-gray-300" data-id="element-1134">
                      AI Web Closer System
                    </span>
                    <span className="font-heading font-bold text-white" data-id="element-1135">
                      ${basePrice}
                    </span>
                  </div>

                  {megaBundleSelected ? <div className="flex items-center justify-between" data-id="element-1136">
                      <span className="font-body text-sm text-gold" data-id="element-1137">
                        🔥 MEGA BUNDLE (8 paquetes)
                      </span>
                      <div className="text-right" data-id="element-1138">
                        <span className="font-body text-xs text-gray-500 line-through mr-1.5" data-id="element-1139">
                          ${allBumpsTotal}
                        </span>
                        <span className="font-heading font-bold text-gold" data-id="element-1140">
                          +${megaBundlePrice}
                        </span>
                      </div>
                    </div> : orderBumps.filter(b => b.selected).map(bump => <div key={bump.id} className="flex items-center justify-between" data-id="element-1141">
                          <span className="font-body text-sm text-gray-300" data-id="element-1142">
                            {bump.title}
                          </span>
                          <span className="font-heading font-bold text-gold" data-id="element-1143">
                            +${bump.price}
                          </span>
                        </div>)}
                </div>

                {/* Total */}
                <div className="pt-4 border-t border-gold/20 mb-6" data-id="element-1144">
                  <div className="flex items-center justify-between mb-2" data-id="element-1145">
                    <span className="font-heading font-bold text-lg" data-id="element-1146">
                      Total Hoy
                    </span>
                    <span className="font-heading font-black text-3xl text-gold" data-id="element-1147">
                      ${totalPrice}
                    </span>
                  </div>
                  <p className="font-body text-xs text-gray-400 text-center" data-id="element-1148">
                    Pago único • Acceso inmediato
                  </p>
                </div>

                {/* CTA Button */}
                <motion.button onClick={e => {
                e.preventDefault();
                redirectToCheckout();
              }} whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="w-full block text-center bg-gold hover:bg-gold-light text-navy font-heading font-bold text-lg px-6 py-4 rounded-xl shadow-2xl transition-all duration-300 mb-4 cursor-pointer" data-id="element-1149">
                  COMPLETAR COMPRA POR ${totalPrice}
                </motion.button>

                {/* Trust Badges */}
                <div className="space-y-2 pt-4 border-t border-gold/10" data-id="element-1150">
                  <div className="flex items-center gap-2 text-gray-400" data-id="element-1151">
                    <LockIcon className="h-4 w-4 text-green-500" data-id="element-1152" />
                    <span className="font-body text-xs" data-id="element-1153">
                      Pago 100% seguro y encriptado
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-400" data-id="element-1154">
                    <ShieldCheckIcon className="h-4 w-4 text-green-500" data-id="element-1155" />
                    <span className="font-body text-xs" data-id="element-1156">
                      Garantía de 30 días
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-400" data-id="element-1157">
                    <CheckCircleIcon className="h-4 w-4 text-green-500" data-id="element-1158" />
                    <span className="font-body text-xs" data-id="element-1159">
                      Acceso inmediato después del pago
                    </span>
                  </div>
                </div>
              </motion.div>

              {/* Money Back Guarantee */}
              <motion.div initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              delay: 0.3
            }} className="mt-4 bg-green-500/10 border border-green-500/30 rounded-lg p-4 text-center" data-id="element-1160">
                <ShieldCheckIcon className="h-8 w-8 text-green-500 mx-auto mb-2" data-id="element-1161" />
                <p className="font-heading font-bold text-sm text-green-500 mb-1" data-id="element-1162">
                  Garantía de 30 Días
                </p>
                <p className="font-body text-xs text-gray-400" data-id="element-1163">
                  Si no consigues ningún cliente interesado, te devolvemos tu
                  dinero
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      {/* Floating Mobile Order Summary */}
      <AnimatePresence data-id="element-1164">
        {!summaryVisible && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed bottom-0 left-0 right-0 z-50 lg:hidden" data-id="element-1165">
            <div className="bg-black border-t-2 border-gold px-4 py-3" style={{
          boxShadow: '0 -8px 30px rgba(0,0,0,0.8), 0 -2px 10px rgba(212,175,55,0.15)'
        }} data-id="element-1166">
              <div className="flex items-center justify-between gap-3" data-id="element-1167">
                <div data-id="element-1168">
                  <p className="font-body text-[10px] text-gray-400" data-id="element-1169">
                    Total hoy
                  </p>
                  <p className="font-heading font-black text-3xl text-gold drop-shadow-lg" data-id="element-1170">
                    ${totalPrice}
                  </p>
                </div>
                <button onClick={e => {
              e.preventDefault();
              redirectToCheckout();
            }} className="flex-1 max-w-[240px] bg-gold hover:bg-gold-light text-navy font-heading font-black text-base px-5 py-3.5 rounded-xl transition-all duration-300" style={{
              boxShadow: '0 4px 20px rgba(212,175,55,0.4)'
            }} data-id="element-1171">
                  COMPLETAR COMPRA
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>

      <RecentPurchaseToast data-id="element-1172" />
    </div>;
}